import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SidebarTrigger } from '@/shared/ui/sidebar';
import { Separator } from '@/shared/ui/separator';

import { ProfileMenu } from './ProfileMenu';
import { Location } from 'react-router';

const routeTitleMap: Record<string, string> = {
  '/bookings': 'bookings.title',
  '/users': 'users.title',
};

export function Header(): React.JSX.Element {
  const { t } = useTranslation();
  const location: Location = useLocation();

  const titleKey: string = routeTitleMap[location.pathname] || 'common.appName';

  return (
    <header
      className="flex items-center justify-between px-6 bg-background border-b border-border shrink-0"
      style={{ height: 'var(--header-height)' }}
    >
      <div className="flex items-center gap-4">
        <SidebarTrigger className="-ml-1" />
        <Separator orientation="vertical" className="mr-2 h-4" />
        <h2 className="text-lg font-semibold tracking-tight text-foreground">{t(titleKey)}</h2>
      </div>

      <ProfileMenu />
    </header>
  );
}
